import { createReducer, on } from "@ngrx/store";
import { ConnectionModel } from "../models/connection.model";
import {
  ADD_CONNECTION,
  ADD_CONNECTIONS,
  UPDATE_CONNECTION,
  UPDATE_CONNECTIONS,
  ADD_CONNECTION_LOCATIONS,
} from "../actions/connection.action";
import { ConnectionLocationMasterModel } from "../models/sap.model";

const INITIAL_CONNECTION: ConnectionModel = {};
const INITIAL_CONNECTIONS: ConnectionModel[] = [];
const INITIAL_CONNECTION_LOCATIONS: ConnectionLocationMasterModel[] = [];

export const ConnectionReducer = createReducer(
  INITIAL_CONNECTION,
  on(ADD_CONNECTION, (_, { connection }) => connection),
  on(UPDATE_CONNECTION, (state, { connection }) => ({
    ...state,
    ...connection,
  })),
);
export const ConnectionLocationsReducer = createReducer(
  INITIAL_CONNECTION_LOCATIONS,
  on(ADD_CONNECTION_LOCATIONS, (_, { connection }) => connection),
);

export const ConnectionsReducer = createReducer(
  INITIAL_CONNECTIONS,
  on(ADD_CONNECTIONS, (_, { connections }) => connections),
  on(UPDATE_CONNECTIONS, (state, { connection }) => {
    const _connection = state.map((stateConnection) =>
      stateConnection?.id === connection?.id
        ? { ...stateConnection, ...connection }
        : stateConnection,
    );

    const assessmentExists = state.find(
      (stateConnection) => stateConnection?.id === connection?.id,
    );
    return assessmentExists ? _connection : [connection, ..._connection];
  }),
);
